'use strict';

/* eslint-disable camelcase */
/**
 * This file will have general utilities
 */

function checkBuildVersion(trueBuildVersion) {
  if (window.location.host.search('mogo.ca') > -1 && Modernizr.localstorage) {
    if (localStorage.getItem('reloaded') == 'true') {
      localStorage.removeItem('reloaded');
    } else if (pageBuildVersion < trueBuildVersion) {
      localStorage.setItem('reloaded', 'true');
      window.location.reload(true);
    }
  }
}

function getURLParameter(name) {
  // The decodeURIComponent() method decodes a Uniform Resource Identifier (URI) component previously created by encodeURIComponent or by a similar routine.
  return decodeURIComponent((new RegExp('[?|&|$]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ''])[1].replace('', '%20')) || null;
}

function getPathPlusVersion() {
  this.path = window.location.pathname;
  this.param = getURLParameter('v');
  this.query = '+v' + this.param;
  this.joined = this.param !== null ? this.path + this.query : this.path;
  this.label = this.joined.substr(1).replace(/\//g, '+');

  return this.label == '' ? 'home' : this.label;
}

// turn string into href so location parts are avail
function getLocation(href) {
  var l = document.createElement('a');
  l.href = href;
  return l;
}

function isSupportedMobileDevice() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return false;
  }
  if (/android/i.test(userAgent)) {
    return true;
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
  }
  if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true;
  }
  return null;
}

$.fn.serializeFormToObj = function (verbose) {
  verbose = verbose == null ? true : verbose;

  var node = this[0];
  if (node.tagName.toLowerCase() != 'form') {
    return null;
  }

  $(node).find('select option:first-child').prop('disabled', false);
  var paramsArr = $(node).serializeArray();
  $(node).find('select option:first-child').prop('disabled', true);

  var resultObj = new Object();
  for (var i = 0; i < paramsArr.length; i++) {
    resultObj[paramsArr[i].name] = paramsArr[i].value;
  }

  // Unselected Select option
  var selects = $('select', node);
  for (var i = 0; i < selects.length; i++) {
    if (!$(selects[i]).val() && selects[i].name != null && selects[i].name != '') {
      resultObj[selects[i].name] = null;
    }
  }

  // Checkboxes
  var checkboxes = $("input[type='checkbox']", node);
  for (var i = 0; i < checkboxes.length; i++) {
    if (verbose || $(checkboxes[i]).parents("[data-mogo-ui='BooleanGroup']").length == 0) {
      if (!checkboxes[i].checked && checkboxes[i].name != null && checkboxes[i].name != '') {
        resultObj[checkboxes[i].name] = false;
      } else {
        resultObj[checkboxes[i].name] = true;
      }
    } else if (!verbose && $(checkboxes[i]).parents("[data-mogo-ui='BooleanGroup']").length > 0) {
      delete resultObj[checkboxes[i].name];
    }
  }

  // Unchecked radios
  var radios = $("input[type='radio']", node);
  for (var i = 0; i < radios.length; i++) {
    if (verbose || $(radios[i]).parents("[data-mogo-ui='BooleanGroup']").length == 0) {
      if (radios[i].name != null && radios[i].name != '' && resultObj[radios[i].name] === undefined) {
        resultObj[radios[i].name] = null;
      }
    } else if (!verbose && $(radios[i]).parents("[data-mogo-ui='BooleanGroup']").length > 0) {
      delete resultObj[radios[i].name];
    }
  }

  // Boolean groups, Collections, and AggregateCollections
  var booleanGroups = $("[data-mogo-ui='BooleanGroup'],[data-mogo-ui='Collection'],[data-mogo-ui='AggregateCollection']", node).filter('[name]');
  for (var i = 0; i < booleanGroups.length; i++) {
    resultObj[$(booleanGroups[i]).attr('name')] = $(booleanGroups[i]).mogo().val();
  }

  return resultObj;
};

// filter for Safari, Edge, IE11 (stricter cookie policy)
function hasStrictCookiePolicy() {
  return (/Edge/.test(navigator.userAgent) || document.getElementsByTagName('html')[0].classList.contains('ie') || /safari/i.test(navigator.userAgent) && !/chrome/i.test(navigator.userAgent)
  );
}

// content string manipulations
var mogoUICoreUtils = {
  insertLinkInTextContent: function insertLinkInTextContent(domId, full_string, linkId, link_text) {
    var str = full_string;
    str = str.replace(link_text, '<a id=' + linkId + '>' + link_text + '</a>');
    $('#' + domId).html(str);
  }
};

// polyfill for IE origin bug
if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

// note: accepts a string and returns a boolean.
// https://rubular.com/r/J7vp0xztiZ4vAo
function isExternalLink(link) {
  var internalLinkRegex = /^(https:\/\/(localhost|(www|qa|dev|demo).mogo.ca)\/member)|^\/member/;
  return !internalLinkRegex.test(link);
}